import { createFormHook } from '@tanstack/react-form';

import { Autocomplete } from './Autocomplete';
import { Checkbox } from './Checkbox';
import { CheckboxGroup } from './CheckboxGroup';
import { DatePicker } from './DatePicker';
import { FileInput } from './FileInput';
import { RadioGroup } from './RadioGroup';
import { Select } from './Select';
import { SubmitButton } from './SubmitButton';
import { TextField } from './TextField';
import { fieldContext, formContext } from './contexts';
import { FormRoot } from './formRoot';

export { fieldContext, formContext, useFieldContext, useFormContext } from './contexts';
export type { Option } from './Select';

export const { useAppForm, withForm } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Autocomplete,
    TextField,
    Select,
    Checkbox,
    CheckboxGroup,
    DatePicker,
    RadioGroup,
    FileInput,
  },
  formComponents: {
    SubmitButton,
    FormRoot,
  },
});
